/** O que os relatórios escrevem do mesmo jeito. */

/** O escopo em palavras de quem lê, como no painel. */
export const ABRANGENCIA: Record<string, string> = {
  tenant: 'toda a organização',
  unidade: 'sua unidade',
  time: 'seu time',
  propria: 'sua carteira',
};

/** Valor por extenso, sem abreviar: num relatório a diferença está nos detalhes. */
export function dinheiro(micros: number, moeda: string): string {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: moeda,
    maximumFractionDigits: 0,
  }).format(micros / 1_000_000);
}

/** Horas em palavras: "36 h", "2 dias e 4 h". */
export function horasEmPalavras(horas: number | null): string {
  if (horas === null) return '—';
  if (horas < 1) return 'menos de 1 h';
  if (horas < 48) return `${Math.round(horas)} h`;
  const dias = Math.floor(horas / 24);
  const resto = Math.round(horas - dias * 24);
  return resto === 0 ? `${dias} dias` : `${dias} dias e ${resto} h`;
}

/** Parte do todo em porcentagem inteira; todo zero não tem porcentagem. */
export const porcentagem = (parte: number, todo: number): string =>
  todo === 0 ? '—' : `${Math.round((parte / todo) * 100)}%`;
